import uniqid from 'uniqid'
import i18n from '@/plugins/vue-i18n'

export default {
  namespaced: true,
  state: {
    alerts: []
  },
  mutations: {
    add (state, payload) {
      state.alerts.push(payload)
    },
    delete (state, payload) {
      let aux = state.alerts.findIndex(x => x.id === payload)
      if (aux >= 0) {
        state.alerts.splice(aux, 1)
      }
    }
  },
  actions: {
    add ({commit, getters}, payload) {
      payload.id = uniqid('alert')
      let previous = getters.getAll.find(x => x.texto === payload.texto)
      if (previous != null) {
        commit('delete', previous.id)
      }
      commit('add', payload)
      setTimeout(() => {
        commit('delete', payload.id)
      }, 6000)
    },
    addTranslated ({ dispatch }, payload) {
      dispatch('add', { texto: i18n.t(payload.texto), color: payload.color})
    },
    addNotLoggedIn ({ getters, dispatch}) {
      if (getters.getAll.filter(x => x.texto === i18n.t('store.iniciarSesion')).length === 0) {
        dispatch('add', { texto: i18n.t('store.iniciarSesion'), color: 'error' })
      }
    },
    delete ({commit}, payload) {
      commit('delete', payload)
    }
  },
  getters: {
    getAll (state) {
      return state.alerts
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/alerts/store.js